module.exports = __webpack_public_path__ + "static/media/vgif.65397e09.gif";